<template>
  <a-modal
    v-model:visible="confirmVisible"
    title="最终确认"
    ok-text="确认提交"
    cancel-text="取消"
    @ok="handleFinalConfirm"
  >
    <div style="padding: 15px">
      <a-alert
        type="warning"
        message="请完整输入「CONFIRM」确认操作"
        style="margin-bottom: 15px"
      />
      <a-input
        v-model:value="confirmText"
        placeholder="请输入大写CONFIRM"
        style="width: 200px"
      />
    </div>
  </a-modal>
  <a-modal v-model:visible="visible" :title="modalTitle" :width="484" @ok="handleOk" :confirm-loading="tableLoading" :after-close="afterClose">
    <div class="mult_operation_wrapper w100 h100 flow_auto">
      <!-- 将警告提示移到模态框内容顶部 -->
      <a-alert
        type="error"
        show-icon
        message="高风险操作提示"
        description="此操作将影响所有关联账户，建议非必要不执行"        style="margin: 12px 0;"
      />
      <a-form class="mult_operation" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :colon="false" label-align="left">
        <section>
          <a-row type="flex" align="middle">
            <a-col :span="24">
              <a-form-item label="拉空类型">
                <a-radio-group v-model:value="formData.projectWeekscheduleUpdateType" button-style="solid">
                  <a-radio :value="'adv'"> 拉空已选账号 </a-radio>
                  <a-radio :value="'product'"> 拉空已选产品
                    <a-tooltip title="高风险操作，请谨慎选择">
                      <exclamation-circle-filled style="color: #ff4d4f; margin-left: 5px;" />
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="生效方式">
                <a-radio-group v-model:value="formData.scheduleScene" button-style="solid">
                  <a-radio :value="'REALTIME'"> 立即生效 </a-radio>
                  <a-radio :value="'NEXT_DAY'"> 次日零点生效</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="修改时段">
                <a-radio-group v-model:value="formData.scheduleTimeType" button-style="solid">
                  <a-radio :value="'unlimited'"> 不限 </a-radio>
                  <a-radio :value="'specific'"> 指定时间段</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="已选时段" v-if="formData.scheduleTimeType === 'specific'">
                <a-textarea v-model:value="formData.scheduleTime" :rows="4" placeholder="请选择时间段" />
              </a-form-item>
            </a-col>
          </a-row>
        </section>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { projectWeekscheduleUpdate } from '@/api/mediaAccount/mediaAccount.js';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue'; // 从正确路径导入
// 在文件顶部添加 h 函数导入
import { h } from 'vue';
export default {
  components: {
    ExclamationCircleFilled
  },
  name: 'ProjectWeekscheduleUpdate',
  emits: ['afterSave'],
  data() {
    const mediaChannel = 'TT' ;
    const businessMode = [];
    const accountList = [];
    const projectCode = [];
    const empty = {projectWeekscheduleUpdateType:'adv',scheduleScene:'REALTIME',scheduleTimeType:'specific'};
    return {
      confirmVisible: false, // 控制输入弹窗
      confirmText: '', // 存储输入内容
      visible: false,
      radioValue: 1,
      componentName: '',
      formData: { ...empty },
      mode: '',
      mediaChannel,
      projectCode,
      tableLoading: false,
      businessMode,
      accountList,
    };
  },
  computed: {
    modalTitle() {
      return { projectWeekscheduleUpdate: '批量拉空' }[this.mode];
    },
  },
  watch: {
    visible(val) {
      console.log(val);
    },
  },
  methods: {
    async handleOk() {
      if (this.formData.projectWeekscheduleUpdateType === 'product') {
        Modal.confirm({
          title: '危险操作警告',
          icon: h(ExclamationCircleFilled, { style: { color: '#ff4d4f' } }), // 修正图标使用方式
          content: h('div', [
            h('div', { style: { color: '#ff4d4f', fontWeight: 'bold' } }, '此操作将永久修改产品排期！'),
            h('div', '可能造成以下影响：'),
            h('ul', { style: 'margin: 5px 0;' }, [
              h('li', '已投放的广告计划可能被中断'),
              h('li', '数据统计将出现异常'),
              h('li', '操作不可逆转')
            ])
          ]),
          okText: '确认执行',
          cancelText: '放弃操作',
          okType: 'danger', // 危险按钮样式
          centered: true,
          onOk: () => {
            // 第二步：打开输入验证弹窗
            this.confirmVisible = true;
          }
        });
      }else {
        await this.weekscheduleUpdate();
      }
    },
    // 新增最终确认方法
    async handleFinalConfirm() {
      if (this.confirmText !== 'CONFIRM') {
        this.$message.error('验证失败，请准确输入CONFIRM');
        return;
      }
      await this.weekscheduleUpdate();
      this.confirmVisible = false;
      this.confirmText = ''; // 清空输入
    },
    // 拉空
    async weekscheduleUpdate() {
      if (this.formData.scheduleTimeType === 'specific') {
        if (this.formData.scheduleTime == null) {
          this.$message.error('请选择时间段');
          return;
        }
        if (!(this.formData.scheduleTime.length === 336)) {
          this.$message.error('时间段格式错误');
          return;
        }else {
          console.log("时间段格式正确:",this.formData.scheduleTime);
        }
      }else {
        this.formData.scheduleTime = '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111';
      }
      this.tableLoading = true;
      let obj = { extras: this.formData, accountList: this.accountList,projectCode: this.projectCode};
      console.log("拉空参数",obj);
      let res ;
      if(this.mediaChannel === 'TT'){
        res = await projectWeekscheduleUpdate(this.mediaChannel,obj);
      }else {
        this.$emit('afterSave');
        this.$message.success('此渠道暂未开通该功能！');
        this.visible = false;
        return ;
      }
      console.log("拉空结果",res);
      if (res.code === 0) {
        this.$emit('afterSave');
        console.log("拉空成功");
        this.$message.success('稍等片刻,拉空时段已提交媒体！');
        this.visible = false;
      }else{
        this.$message.error(res.msg);
        this.visible = false;
      }
      this.tableLoading = false;
      return ;
    },
    // 关闭批量绑定弹框
    afterClose() {
    },
  },
};
</script>

<style  lang="less">
.mult_operation {
  overflow: auto;

  .ant-form-item-label {
    line-height: 40px;
  }
  .anticon-question-circle svg {
    font-size: 14px;
  }
  .ant-calendar-picker-input {
    height: 32px !important;
  }
  .ant-radio-button-wrapper {
    width: 96px;
    text-align: center;
  }
}

</style>
